'use client';
import { ComponentType } from 'react';
import { HeightSinceWidth } from '../placeholder/placeholder.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './school-start.component';
import dynamic from 'next/dynamic';

const DynamicSchoolStartComponent: ComponentType<Props> = dynamic(
  () => import('./school-start.component')
);

export default DynamicSchoolStartComponent;

export function calculateSchoolStartPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth: HeightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 230 },
    { sinceWidth: 1024, height: 605 }
  ];

  return {
    heightSinceWidth
  };
}
